import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { IconButton, Popover, useTheme } from '@mui/material';
import classNames from 'classnames';

import LanguageItem from './LanguageItem';
import makeStyles from '@mui/styles/makeStyles';
import CmtCard from '../../../../../@coremat/CmtCard';
import CmtCardHeader from '../../../../../@coremat/CmtCard/CmtCardHeader';
import CmtList from '../../../../../@coremat/CmtList';
import { languageData } from './data';
import { patchProfile, updateLanguage } from 'redux/Account/AccountAction';

import { useTranslation } from 'react-i18next';
import moment from 'moment';
import axios from 'axios';
import { Language } from '@mui/icons-material';
import { LanguageEnumValue } from 'enums/LanguageEnum';
import { localeStorageLanguageKey } from 'config/config';
const useStyles = makeStyles(() => ({
  cardRoot: {
    '& .Cmt-header-root': {
      paddingTop: 14,
      paddingBottom: 14,
    },
  },
  perfectScrollbarLanguage: {
    height: 'fit-content',
  },
  menuItemRoot: {
    paddingTop: 0,
    paddingBottom: 0,
    '&:hover': {
      backgroundColor: 'transparent',
    },
  },
  popoverRoot: {
    '& .MuiPopover-paper': {
      width: 205,
    },
  },
  caret: {
    transition: 'all 150ms ease-in',
    display: 'inline-block',
    width: '0',
    height: '0',
    marginLeft: '4px',
    verticalAlign: 'middle',
    borderTop: '4px solid',
    borderRight: '4px solid transparent',
    borderLeft: '4px solid transparent',
  },
  caretActive: {
    transform: 'rotate(180deg)',
  },
  caretDropup: {
    transform: 'rotate(180deg)',
  },
  white: {
    color: 'white',
  },
}));

const LanguageSwitcher = () => {
  const classes = useStyles();
  const [anchorEl, setAnchorEl] = useState(null);
  const theme = useTheme();
  const { t, i18n } = useTranslation();
  const dispatch = useDispatch();
  const accountReducer = useSelector(state => state.AccountReducer);
  const { profile } = accountReducer;

  const handleClick = event => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const open = Boolean(anchorEl);
  const id = open ? 'languages' : undefined;

  const switchLanguage = ({ locale, icon }) => {
    axios.defaults.headers.common['Accept-Language'] = locale;
    i18n.changeLanguage(locale);

    localStorage.setItem(localeStorageLanguageKey, locale);

    if (locale === 'fr') moment.locale('fr-CA');
    else moment.locale('en-CA');

    const languageEnumValue =
      locale === 'fr' ? LanguageEnumValue.FRENCH : locale === 'en' ? LanguageEnumValue.ENGLISH : LanguageEnumValue.OTHER;

    let attachedFileModel = {
      fieldValues: [
        {
          value: languageEnumValue,
          fieldName: 'person.languageEnum',
        },
      ],
      profile,
    };

    dispatch(patchProfile(attachedFileModel));
    dispatch(updateLanguage(locale + '-' + icon.toUpperCase()));
    handleClose();
  };

  const caretClasses = classNames({
    [classes.caret]: true,
    [classes.caretActive]: open,
  });

  return (
    <React.Fragment>
      <IconButton size="small" onClick={handleClick} className={classes.white} data-tut="reactour__localization">
        <Language />
        <b className={caretClasses} />
      </IconButton>

      <Popover
        className={classes.popoverRoot}
        id={id}
        open={open}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'right',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'right',
        }}>
        <CmtCard className={classes.cardRoot}>
          <CmtCardHeader
            title={t('languages')}
            separator={{
              color: theme.palette.borderColor.dark,
              borderWidth: 1,
              borderStyle: 'solid',
            }}
          />
          <CmtList
            data={languageData}
            renderRow={(item, index) => <LanguageItem key={index} language={item} onClick={switchLanguage} />}
          />
        </CmtCard>
      </Popover>
    </React.Fragment>
  );
};

export default LanguageSwitcher;
